/**
 * @file Album Folder Upload Reducer.
 */
import {
  ALBUM_FOLDER_UPLOAD_REQUEST,
  ALBUM_FOLDER_UPLOAD_SUCCESS,
  ALBUM_FOLDER_UPLOAD_FAILURE,
  ALBUM_FOLDER_RESET,
  ALBUM_FOLDER_PHOTO_UPLOAD_SUCCESS,
  ALBUM_FOLDER_PHOTO_UPLOAD_FAILURE,
  ALBUM_FOLDER_CANCEL_UPLOAD_REQUEST,
  ALBUM_FOLDER_CANCEL_UPLOAD_SUCCESS,
  ALBUM_FOLDER_RETRY,
  ALBUM_FOLDER_UPLOAD_SET_PHOTO_BATCH,
} from '../actions/album-folder-upload';
import { UPLOAD_RESET } from '../apps/pro/redux/fileUpload/fileUploadActions';

export const initialState = {
  total: 0,
  current: 0,
  error: null,
  success: false,
  uploading: false,
  uploadedPhotos: [],
  failedPhotos: [],
  cancel: false,
  cancelReason: null,
  retry: false,
  photoBatchId: '',
};

const albumFolderUploadsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ALBUM_FOLDER_UPLOAD_REQUEST:
      return {
        ...initialState,
        total: action.photos.length,
        uploading: true,
        error: null,
        uploadedPhotos: state.retry ? state.uploadedPhotos : [],
        failedPhotos: [],
        current: 0,
        cancelReason: null,
        cancel: false,
      };
    case ALBUM_FOLDER_PHOTO_UPLOAD_SUCCESS:
      return {
        ...state,
        current: state.current + 1,
        uploadedPhotos: [...state.uploadedPhotos, action.photo],
      };
    case ALBUM_FOLDER_PHOTO_UPLOAD_FAILURE:
      return {
        ...state,
        current: state.current + 1,
        failedPhotos: [
          ...state.failedPhotos,
          {
            photo: action.photo,
            error: action.error,
          },
        ],
      };

    case ALBUM_FOLDER_UPLOAD_SUCCESS:
      return {
        ...state,
        uploading: false,
        success: true,
        error: null,
        retry: false,
      };

    case ALBUM_FOLDER_UPLOAD_FAILURE:
      return {
        ...state,
        success: false,
        uploading: false,
        error: action.error,
        retry: false,
      };

    case ALBUM_FOLDER_RESET:
    case UPLOAD_RESET:
      return {
        ...initialState,
      };

    case ALBUM_FOLDER_CANCEL_UPLOAD_REQUEST:
      return {
        ...state,
        cancel: true,
        cancelReason: action.cancelReason || null,
      };
    case ALBUM_FOLDER_UPLOAD_SET_PHOTO_BATCH:
      return {
        ...state,
        photoBatchId: action.photoBatch?.id,
      };
    case ALBUM_FOLDER_RETRY:
      return {
        ...state,
        retry: true,
      };

    case ALBUM_FOLDER_CANCEL_UPLOAD_SUCCESS:
      return {
        ...state,
        cancel: false,
      };

    default:
      return state;
  }
};

export default albumFolderUploadsReducer;
